"use client";

import { useState } from "react";
import { Button, Card } from "@/components/ui";

function at(): "yazi" | "tura" {
  const buf = new Uint8Array(1);
  crypto.getRandomValues(buf);
  return buf[0] % 2 === 0 ? "yazi" : "tura";
}

export function YaziTuraTool() {
  const [sonuc, setSonuc] = useState<"yazi" | "tura" | null>(null);
  const [donuyor, setDonuyor] = useState(false);
  const [sayac, setSayac] = useState({ yazi: 0, tura: 0 });

  function paraAt() {
    setDonuyor(true);
    const s = at();
    setTimeout(() => {
      setSonuc(s);
      setSayac((c) => ({ ...c, [s]: c[s] + 1 }));
      setDonuyor(false);
    }, 600);
  }

  return (
    <div className="space-y-4">
      <div className="grid place-items-center rounded-2xl border border-border bg-surface-muted py-12">
        <div
          className={`grid size-32 place-items-center rounded-full text-3xl font-bold text-white shadow-lg transition ${donuyor ? "animate-spin" : ""}`}
          style={{ background: "linear-gradient(135deg,#7c5cff,#22c55e)" }}
        >
          {donuyor ? "?" : sonuc === "yazi" ? "YAZI" : sonuc === "tura" ? "TURA" : "?"}
        </div>
        {sonuc && !donuyor && (
          <p className="mt-4 text-lg font-semibold text-brand">
            {sonuc === "yazi" ? "Yazı geldi!" : "Tura geldi!"}
          </p>
        )}
      </div>

      <Button onClick={paraAt} loading={donuyor} className="w-full sm:w-auto">
        Para at
      </Button>

      {(sayac.yazi > 0 || sayac.tura > 0) && (
        <Card className="flex items-center justify-around text-center">
          <div>
            <p className="text-2xl font-bold tabular-nums">{sayac.yazi}</p>
            <p className="text-sm text-muted">Yazı</p>
          </div>
          <div className="h-10 w-px bg-border" />
          <div>
            <p className="text-2xl font-bold tabular-nums">{sayac.tura}</p>
            <p className="text-sm text-muted">Tura</p>
          </div>
          <div className="h-10 w-px bg-border" />
          <div>
            <p className="text-2xl font-bold tabular-nums">{sayac.yazi + sayac.tura}</p>
            <p className="text-sm text-muted">Toplam</p>
          </div>
        </Card>
      )}

      <p className="text-sm text-muted">Sonuç adil rastgele üreticiyle belirlenir (%50-%50). Hiçbir veri gönderilmez.</p>
    </div>
  );
}
